// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1MtJr","notes":"Notes_notes__1jCuA"};